/** Whether a block's output travelled with the response or was left out for size. */
export var FlowRunBlockOutputStatus;
(function (FlowRunBlockOutputStatus) {
    FlowRunBlockOutputStatus["Inline"] = "Inline";
    FlowRunBlockOutputStatus["Omitted"] = "Omitted";
})(FlowRunBlockOutputStatus || (FlowRunBlockOutputStatus = {}));
//# sourceMappingURL=blockOutputStatus.js.map